import { useRouter } from 'next/router'

export const useListId = (listId?: string): string | undefined => {
  const router = useRouter()

  return (router?.query?.listId as string) ?? (router?.query?.subscriptionId as string) ?? listId
}
